/* eslint-disable @typescript-eslint/no-unused-vars */
import { Handle, Position } from '@xyflow/react'
import plcLogo from '@/assets/energy-system.png'

function ControlSystemNode({ data, isConnectable }) {
  return (
    <div className="custom-node-plc plc-limits">
      <Handle type="target" position={Position.Left} />

      <div className="grid grid-cols-1">
        <div>
          <div></div>
          <div className="text-center">
            <img src={plcLogo} alt="Control System Logo" className="custom-node-plc-logo" />
          </div>
          <div className="text-center">
            <b>Control System</b>
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Right} />
      <Handle type="target" id="right" position={Position.Right} />
    </div>
  )
}

export default ControlSystemNode
